import { BrandMemberRole } from '../types/enums';
import i18n from '../i18n';

export const getInfoText = (role: string): string => {
  switch (role.toLowerCase()) {
    case BrandMemberRole.User:
      return i18n.t('userManagement.roleDescriptions.user', {
        defaultValue:
          'Can view smartlinks and campaigns. Cannot create, edit, delete, invite, or manage payments.',
      });
    case BrandMemberRole.Manager:
      return i18n.t('userManagement.roleDescriptions.manager', {
        defaultValue:
          'Can create and edit smartlinks and campaigns, view analytics, and invite team members.Cannot delete items, approve content, or manage payments.',
      });
    case BrandMemberRole.Admin:
      return i18n.t('userManagement.roleDescriptions.admin', {
        defaultValue:
          'Full access to smartlinks, campaigns, payments, and team settings.Can create, edit, delete, invite, approve, and manage all actions.',
      });
    default:
      return '';
  }
};
